export default __webpack_public_path__ + "static/media/G_D_btn__Archivio.af0c5172.svg";